import React, { useEffect, useState, useContext, useRef } from 'react';
import $ from 'jquery';
import { GetCoockie, ValidateQty, shopping_cart_session_id, CheckSession, DefaultImage, KImageURL, FormatCurrency } from "../GlobalScript";
import Modal from 'react-bootstrap/Modal';
import CloseButton from 'react-bootstrap/CloseButton';
import Button from 'react-bootstrap/Button';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import PulseLoader from "react-spinners/PulseLoader";
import { useTranslation, Trans } from 'react-i18next';

const generateInitialState = (numRows, initialValues) => {
    let initialState = Array.from({ length: numRows }, () => ({ sku: '', qty: '' }));
    
    if (initialValues && initialValues.length <= numRows) {
        let idx = 0;
        initialValues.forEach(element => {
            initialState[idx].sku = element.sku;
            initialState[idx++].qty = element.qty;
        });
    }
    return initialState;
}

const ItemInquiry = ({ show, handleClose, handleSelectedItems, initialValues, orderType, autoSubmit, bulkLoadData, fromImport }) => {

    const { t } = useTranslation();
    const numRows = 10;
   
    const [searchItems, setSearchItems] = useState(false);
    const [selectMode, setSelectMode] = useState(true);
    const [selectAll, setSelectAll] = useState(false);
    const [SKUItems, setSKUItems] = useState(new Map());
    const [AddSKUError, setAddSKUError] = useState([]);
    const [ItemsSubtotal, setItemsSubtotal] = useState(0);
    const [SelectedSKUs, setSelectedSKUs] = useState(new Set());
    const [ShowAddToOrder, setShowAddToOrder] = useState(false);
    const [SubstitutionSkus, setSubstitutionSkus] = useState(null);
    //const [BulkData, setBulkData] = useState(bulkLoadData);
    const [BulkData, setBulkData] = useState(null);
    const [pop, setPop] = useState(false);
    const [Typing, setTyping] = useState(false);
    const [showModelModal, setShowModelModal] = useState(false);
    const [alerts, setAlerts] = useState([]);
    const [AlertLTL, setAlertLTL] = useState(false);
    const [alertPk, setAlertPk] = useState(false);
    const [AlertFactorCount, setAlertFactorCount] = useState(0);
    const [AlertBOCount, setAlertBOCount] = useState(0);
    const [Models, setModels] = useState(null);
    const [SelectedItemForModels, setSelectedItemForModels] = useState(null);
    const [localFromImport, setLocalFromImport] = useState(fromImport ? fromImport : false);
    const [invalidSkus, setInvalidSkus] = useState(new Set());

    const inputRefs = useRef([]);

    const handlePop = () => setPop(true);
    const handleClosePop = () => {
        setPop(false);
    }

    const handleModelModalShow = (itemNum) => {
        GetModels(itemNum);
        setShowModelModal(true);
    }

    const GetModels = async (itemnum) => {
        CheckSession();
        const response = await fetch("kdealer/GetModels/" + itemnum);
        if (response.status !== 200) {
            return;
        }
        const js = await response.json();
        const grouped = Object.groupBy(js.models, ({ year }) => year);
        const sortedGroups = Object.entries(grouped)
            .sort(([groupA], [groupB]) => groupB.localeCompare(groupA))
            .map(([group, models]) => {
                models.sort((a, b) => a.label - b.label);
                return { group, models };
            });
        setSelectedItemForModels({ itemNum: js.itemNum, itemName: js.itemName })
        console.log(sortedGroups);
        setModels(sortedGroups);
    }
    const handleModelModalClose = () => setShowModelModal(false);

    useEffect(() => {
        setLocalFromImport(fromImport);
    }, [fromImport])
    
    const [rows, setRows] = useState(generateInitialState(numRows, initialValues));
    useEffect(() => {
        resetItems();
        setRows(generateInitialState(numRows, initialValues));
        if (initialValues && initialValues.length > numRows) {
            setBulkData(initialValues);
        }
        setSearchItems(true);
    }, [initialValues]);

    useEffect(() => {
        resetItems();
        if (bulkLoadData) {
            setBulkData(bulkLoadData);
        }
        if (BulkData && BulkData.length > 0) {
            GetSKUDetail(BulkData);
        }
    }, [BulkData, bulkLoadData]);

    useEffect(() => {
        if (autoSubmit && initialValues.length > 0 && !Typing) {
            AddSkuClick();
            setTyping(false);
        }
    }, [rows]);

    useEffect(() => {
        setShowAddToOrder(SelectedSKUs.size > 0);
    }, [SelectedSKUs.size]);

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const newRows = [...rows];
        newRows[index][name] = value;
        if (name === "qty") {
            let newQty = ValidateQty(value);
            newRows[index][name] = newQty;
        } else if (name === "sku") {
            newRows[index][name] = value;
        }
        setRows(newRows);
        setTyping(true);
    };

    const resetItems = () => {
        setRows(generateInitialState(numRows));
        setSKUItems(new Map());
        setAddSKUError([]);
        setInvalidSkus(new Set());
    }

    const handleSelectItem = (e) => {
        const sku = e.target.id.substring(5).replaceAll('-', '');
        const set = new Set(SelectedSKUs);
        if (e.target.checked) {
            set.add(sku);
        } else {
            set.delete(sku);
        }
        if (set.size < SelectedSKUs.size) {
            setSelectAll(false);
        }
        setSelectedSKUs(set);       
    }

    const handleSubmit = (event) => {
        let skuObjs = [];

        const alerts = [
            AlertFactorCount > 0 && { type: 'packQuantity' },
            AlertBOCount > 0 && { type: 'backorder' },
            AlertLTL && { type: 'ltlShipping' },
            SubstitutionSkus.length > 0 && { type: 'substitutions' }
        ].filter(Boolean);

        SelectedSKUs.forEach(value => {
            skuObjs.push(SKUItems.get(value));
            //console.log(SKUItems.get(value).item);
        });
        if (skuObjs.length === 0) {
            return;
        }
        if (handleSelectedItems) {
            handleSelectedItems({ items: skuObjs, alerts: alerts }, false);
            //handleSelectedItems(skuObjs, AccSubtotal);
            //if (UpdateContextFromOutside) {
            //    UpdateContextFromOutside(skuObjs);
            //}
        }   
        setBulkData(null);
        resetItems();
        if (fromImport) {
            setLocalFromImport(false);
        }
        handleClose();
        //window.location.reload();
    }   

    const LoadBulkSkus = async () => {
        if (!bulkLoadData || bulkLoadData.length === 0) {
            return;
        }
    }

    const ValidateSKUData = async () => {
        try {
            /*debugger;*/
            handlePop();
            CheckSession();
            $(':input').removeClass('is-invalid');
           
            let validatedArr = [];
            for (let i = 0; i < rows.length; i++) {
                let qtyint = parseInt(rows[i].qty);
                if (isNaN(qtyint) || qtyint <= 0) {
                    qtyint = 1;
                }
                if (rows[i].sku) {
                    validatedArr.push({
                        sku: rows[i].sku.trim(),
                        qty: qtyint,
                        //orderType: orderType
                    });
                } else if (rows[i].sku || rows[i].qty) {
                    const itmId = '#CtrlItemNum' + i;
                    const qtyId = '#CtrlQty' + i;
                    if (rows[i].sku) {
                        $(itmId).removeClass('is-invalid');
                    } else {
                        $(itmId).addClass('is-invalid');
                    }
                    if (rows[i].qty) {
                        $(qtyId).removeClass('is-invalid');
                    } else {
                        $(qtyId).addClass('is-invalid');
                    }
                }
            }
            handleClosePop();
            return validatedArr;
        }
        catch (e) {
            handleClosePop();
            console.log(e);
            return null;
        }
    }

    const GetSKUDetail = async (validatedArr) => {
        try {
            if (validatedArr.length === 0) {
                return;
            }
            CheckSession();
            setSKUItems(new Map());
            setSelectedSKUs(new Set());
            handlePop();
            const user = GetCoockie();
            //Item availability
            const skuqty = {
                valueLabels: validatedArr,
                orderType: orderType.toString(),
                dealerID: user.dealerID,
                userKey: user.userKey
            };
            const rqst = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(skuqty)
            };
            const res = await fetch('kdealer/GetSkuInfo/', rqst);
            if (res.status !== 200) {
                throw new Error(res.statusText);
            }
            const js = await res.json();
            console.log(SKUItems.values());

            const addInfo = new Map();
            const newSkuQty = []; 
            const arrSubs = [];
            let errorSet = new Set();
            const invalidSet = new Set();
            setAlertLTL(false);
            let alertFactor = 0, boCount = 0;
            console.log(js);

            const validSet = new Set(
                js.map(item => item.distitemNbr?.toLowerCase().replaceAll('-', '')).filter(Boolean)
            );

            rows.forEach(row => {
                const normalizedInput = row.sku.toLowerCase().replaceAll('-', '');
                if (row.sku !== "" && !validSet.has(normalizedInput)) {
                    invalidSet.add(normalizedInput);
                }
            });

            js.map((item) => {
                const normalizedItem = item.distitemNbr?.toLowerCase().replaceAll('-', '');

                if (item.errorMsg?.toLowerCase().includes("invalid") || item.itemStaCode === "4") {
                    if (normalizedItem) {
                        invalidSet.add(normalizedItem);
                    }
                }

                if (item.distitemNbr !== "") {
                    newSkuQty.push({
                        sku: item.distitemNbr,
                        qty: item.qty
                    });
                    if (item.substitutedSKU !== "") {
                        arrSubs.push(`${item.substitutedSKU} is substituted by ${item.distitemNbr}`);
                    }
                    if (item.ltl === true) {
                        setAlertLTL(true);
                    }
                    if (item.pk === true) {
                        setAlertPk(true);
                    }
                    if (item.itemStaCode === "4") {
                        item.qty = 0;
                    }

                    if (item.factorAlert) {
                        alertFactor++;
                    }
                    if (item.boCnt > 0) {
                        boCount++;
                    }
                }

                if (item.errorMsg !== "") {
                    if (item.errorMsg.toLowerCase().indexOf("invalid") > -1) {
                        errorSet.add("Please correct the invalid item numbers below.");
                    } else {
                        errorSet.add(item.errorMsg);
                    }
                }
                return '';
            });

            setInvalidSkus(invalidSet);
            setAlertBOCount(boCount);
            setSubstitutionSkus(arrSubs);
            setAlertFactorCount(alertFactor);
            //Item Number
            const skuqty2 = {
                valueLabels: newSkuQty,
                orderType: orderType.toString(),
                dealerID: user.dealerID
            };
            const rqst2 = {
                method: 'POST',
                headers: {
                    'Content-type': 'application/json'
                },
                body: JSON.stringify(skuqty2)
            };
            const res2 = await fetch('kdealer/GetSkuInfo2/', rqst2);
            if (res2.status !== 200) {
                handleClosePop();
                throw new Error(res.statusText);
            }
            const js2 = await res2.json();

            js2.map((item) => {
                if (item.itemStaCode === "1") {
                    addInfo.set(item.itemNumber.replaceAll('-', ''), item);
                }
                return '';
            });

            //let arr = [];
            let acctotal = 0;
            //let errorSet = new Set();

            js.map((item) => {
                if (item.distitemNbr !== "") {
                    const newDistrNum = item.distitemNbr.replaceAll('-', '');
                    const info = {
                        item: item,
                        addInfo: addInfo.get(newDistrNum)
                    }
                    if (item.itemStaCode === "1" || item.itemStaCode === "2") {
                        setSelectedSKUs(prev => new Set(prev).add(newDistrNum));
                        acctotal += item.qty * item.dealerPrice;
                    }
                    setSKUItems(prevSKUItems => new Map(prevSKUItems).set(newDistrNum, info));
                }
                return '';
            });
            console.log(SKUItems.size);
            setAddSKUError(Array.from(errorSet));
            setItemsSubtotal(acctotal);
            handleClosePop();
        } catch (e) {
            handleClosePop();
            console.log(e);
            return;
        }
    }

    const AddSkuClick = async () => {
        const data = await ValidateSKUData();
        GetSKUDetail(data);
        handleSelectAll();
    }

    const selectAllItems = () => {
        const skuArray = Array.from(SKUItems.values());
        const set = new Set();
        if (selectMode) {
            for (let i = 0; i < skuArray.length; i++) {
                set.add(skuArray[i].item.distitemNbr.replaceAll('-', ''));
            }
        }
        setSelectedSKUs(set);
        setSelectMode(prev => !prev);
    }

    const handleSelectAll = () => {
        const skuArray = Array.from(SKUItems.values());
        const set = new Set();
        for (let i = 0; i < skuArray.length; i++) {
            set.add(skuArray[i].item.distitemNbr.replaceAll('-', ''));
        }
        setSelectedSKUs(set);

        if (selectAll) {
            setSelectAll(false);
            setSelectedSKUs(new Set());
        } else {
            setSelectAll(true);
        }
    }

    useEffect(() => {
        if (SelectedSKUs.size === SKUItems.size) {
            setSelectAll(true);
        }
    }, [SelectedSKUs, SKUItems])

    useEffect(() => {
        const skuArray = Array.from(SKUItems.values());
        if (SelectedSKUs.size < skuArray.length) {
            setSelectMode(true);
        }
    }, [SelectedSKUs, SKUItems])

    const getStatusIcon = (code) => {
        const color = code.charAt(0);
        const number = code.slice(1);

        switch (color) {
            case "G":
                return (
                    <div className="icons-row">
                        <div className="status-icon green-icon"></div>
                        {/*<span>{parseFloat(number)}</span>*/}
                    </div>
                );
            case "Y":
                return (
                    <div className="icons-row">
                        <div className="status-icon yellow-icon"></div>
                        {/*<span>{parseFloat(number)}</span>*/}
                    </div>
                );
            default:
                return (
                    <div className="icons-row">
                        <div className="status-icon red-icon"></div>
                        {/*<span>{parseFloat(number)}</span>*/}
                    </div>
                );
        }
    };

    return (
        <>
            <Modal show={show} onHide={handleClose} scrollable size="lg" dialogClassName="modal-90w dealer-section item-inquiry-modal" style={showModelModal && {zIndex: 100}}>
                <Modal.Header closeButton>
                    <Row className="w-100w">
                        <Col sm={3}>
                            <Modal.Title>{localFromImport ? 'IMPORT INSTRUCTIONS' : t('iteminquiry.ITEM INQUIRY')}</Modal.Title>
                        </Col>

                        {SKUItems.size > 0 &&
                            <>
                                <Col sm={{ span: 8, offset: 1 }}>
                                <Modal.Title className="text-left">
                                    {localFromImport ? 'IMPORT RESULTS' : t('iteminquiry.ITEM INQUIRY RESULTS') }
                                </Modal.Title>
                                </Col>
                            </>
                        }
                    </Row>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} md={6} lg={4} xl={3} className="item-inquiry-search">
                            <div className="sticky">

                                {localFromImport ?
                                    <>
                                        <h3 className="mt-5 bold">Before adding imported items to the cart:</h3>

                                        <ol className="mb-5 mt-4 text-left">
                                            <li>Review the Item Numbers and Quantities</li>
                                            <li>Review Item Availability</li>
                                            <li>Uncheck any item(s) you want to remove</li>
                                            <li>Click Add to Order</li>
                                        </ol>
                                    </>
                                :
                                    <>
                                        {AddSKUError.length > 0 &&
                                            <>
                                                {AddSKUError.map((d, idx) =>
                                                    <p className="red mt-2" key={"error" + idx}>{d}</p>)
                                                }
                                            </>
                                        }

                                        <p className="bold text-left mt-2">{t('iteminquiry.Search Up to 10 Items')}</p>

                                        <Row>
                                            <Col>
                                                <p className="red mb-0">{t('iteminquiry.Required')}</p>
                                            </Col>
                                            <Col>
                                                <p className="text-right mb-0 padding-right-extra">{t('iteminquiry.Optional')}</p>
                                            </Col>
                                        </Row>

                                        {rows.map((row, index) => {
                                            const normalizedInput = row.sku.toLowerCase().replaceAll('-', '');
                                            const isInvalid = invalidSkus.has(normalizedInput);

                                            return (
                                                <div key={index} className="form-group">
                                                    <Row className="item-inquiry-search-row mb-1">
                                                        <Col sm={1} lg={1} xl={1} className="mt-3 no-padding-right">{index + 1}</Col>
                                                        <Col sm={8} lg={7} xl={8}>
                                                            <FloatingLabel controlId={"CtrlItemNum" + index} label={t("textfield.Item Number")}>
                                                                <Form.Control
                                                                    placeholder={t("textfield.Item Number")}
                                                                    value={row.sku}
                                                                    onChange={(event) => handleInputChange(index, event)}
                                                                    className={isInvalid ? "red-alert-input form-control" : "form-control"}
                                                                    name="sku"
                                                                    ref={(el) => (inputRefs.current[index] = el)}
                                                                />
                                                            </FloatingLabel>
                                                        </Col>
                                                        <Col sm={3} col lg={4} xl={3}>
                                                            <FloatingLabel controlId={"CtrlQty" + index} label={t("textfield.Qty")}>
                                                                <Form.Control placeholder="Qty" value={row.qty} onChange={(event) => handleInputChange(index, event)} className="form-control" name="qty" />
                                                            </FloatingLabel>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            )
                                        })}
                                    </>
                                }
                        
                            </div>
                        </Col>

                        <Col sm={12} md={6} lg={8} xl={9} className="mt-2">
                            {SKUItems.size > 0 ?
                                <>
                                    <div className="sticky fixed-legend">
                                        <Row className="table-legend g-0">
                                            <Col sm={2} className="text-left padding-left-extra">
                                                {/*<Button variant={selectMode ? "outline-dark" : "dark"} onClick={selectAllItems}>{selectMode ? "Select All" : "Unselect All"}</Button>*/}
                                                <Form.Check
                                                    type="checkbox"
                                                    name="selectAll"
                                                    aria-label='Select All'
                                                    label={t("form.Select All")}
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                />
                                            </Col>
                                            <Col sm={10}>
                                                <div className="table-legend-section">
                                                    <span className="svg-holder"><img src="../../../Images/parts.svg" alt="" className="" /> Parts</span>
                                                    <span className="svg-holder"><img src="../../../Images/accessories.svg" alt="" className="" /> Accessories</span>
                                                    <span className="svg-holder"><img src="../../../Images/other.svg" alt="" className="" /> Other</span>
                                                </div>

                                                <div className="table-legend-section">
                                                    <span className="icons-row"><div className={`status-icon green-icon`}></div> Available</span>
                                                    <span className="icons-row"><div className={`status-icon yellow-icon`}></div> Partial</span>
                                                    <span className="icons-row"><div className={`status-icon red-icon`}></div> Unavailable</span>
                                                </div>

                                                <div className="table-legend-section">
                                                    <span className="svg-holder"><img className="asterisk-img" src={"../../../Images/asterisk.svg"} alt="asterisk" /> Pkg Qty</span>
                                                    <span className="svg-holder"><img src="../../../Images/substitute.svg" alt="" className="" /> Substitute</span>
                                                    <span className="svg-holder"><img className="" src={"../../../Images/LTL.svg"} alt="LTL" /> LTL</span>
                                                    <span className="svg-holder"><img src="../../../Images/backorder.svg" alt="" className="" /> Backorder</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    <div className="item-inquiry-list">
                                        <div className="alerts-section" style={AlertFactorCount < 1 && !AlertLTL && SubstitutionSkus.length < 1 && ItemsSubtotal < 1000 && AlertBOCount < 1 && !alertPk ? { border: "none" } : {}} >
                                            <Row>
                                                {AlertFactorCount > 0 &&
                                                    <Col sm={12}>
                                                        <div className="icons-row alert-noti asterisk-noti text-left">
                                                            <span className="svg-holder small-svg">
                                                                <img className="asterisk-img" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                            </span>

                                                            <p className="mb-0">There {AlertFactorCount === 1 ? `is ${AlertFactorCount} item` : `are ${AlertFactorCount} items`} with the order quantity increased to a factor of the package quantity.</p>
                                                        </div>
                                                    </Col>
                                                }
                                                {AlertLTL === true &&
                                                    <Col sm={12}>
                                                        <div className="icons-row alert-noti ltl-noti text-left">
                                                            <span className="svg-holder small-svg">
                                                                <img className="" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                            </span>

                                                            <p className="mb-0">Your whole order may ship LTL due to restrictions on the highlighted item(s)</p>
                                                        </div>
                                                    </Col>
                                                }
                                                {SubstitutionSkus.length > 0 && 
                                                    <Col sm={12}>
                                                        <div className="icons-row alert-noti substitute-noti text-left">
                                                            <span className="svg-holder small-svg">
                                                                <img className="red-filter" src={"../../../Images/substitute.svg"} alt="Substitute"></img>
                                                            </span>

                                                            <p className="mb-0">One or more items has been substituted on this order.</p>
                                                        </div>
                                                    </Col>
                                                }
                                                {AlertBOCount > 0 &&
                                                    <Col sm={12}>
                                                        <div className="icons-row alert-noti bo-noti text-left">
                                                            <span className="svg-holder small-svg">
                                                                <img src="../../../Images/backorder.svg" alt="Alert" />
                                                            </span>

                                                            <p className="mb-0">One or more items are backordered</p>
                                                        </div>
                                                    </Col>
                                                }
                                                {alertPk &&
                                                    <Col sm={12}>
                                                        <div className="icons-row alert-noti bo-noti text-left">
                                                            <span className="svg-holder small-svg">
                                                                <img src="../../../Images/backorder.svg" alt="Alert" />
                                                            </span>

                                                            <p className="mb-0">One or more packages built to order</p>
                                                        </div>
                                                    </Col>    
                                                }
                                                {ItemsSubtotal > 1000 &&
                                                    <Col sm={12}>
                                                        <div className="icons-row alert-noti bo-noti text-left">
                                                            <p className="red mb-0 text-left padding-left-extra">Air shipping options are not available for orders totalling $1000.00 or more.</p>
                                                        </div>
                                                    </Col>
                                                }
                                            </Row>
                                        </div>

                                        {[...SKUItems.values()].map((d, idx) => (
                                            <div key={"sku" + idx.toString()} className="item-inquiry-item">
                                                <Row>
                                                    {d.item.factorAlert &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti asterisk-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img className="asterisk-img white-filter" src={"../../../Images/asterisk.svg"} alt="asterisk"></img>
                                                                </span>

                                                                <p className="mb-0">This item's quantity has been increased to a factor of the package quantity.</p>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {d.item.ltl &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti ltl-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img className="white-filter" src={"../../../Images/LTL.svg"} alt="LTL"></img>
                                                                </span>

                                                                <p className="mb-0">Your whole order may ship LTL due to restrictions on the highlighted item(s)</p>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {d.item.substitutedSKU !== '' &&
                                                        <Col sm={12}>
                                                            <div className="icons-row substitute-noti alert-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img className="white-filter" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img>
                                                                </span>

                                                                <p className="mb-0">Item No: {d.item.substitutedSKU} is substituted by Item No: {d.item.distitemNbr}</p>
                                                            </div>
                                                        </Col>
                                                    }
                                                    {d.item.pk &&
                                                        <Col sm={12}>
                                                            <div className="icons-row substitute-noti alert-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                </span>

                                                                <p className="mb-0">Packages built to order</p>
                                                            </div>
                                                        </Col> 
                                                    }
                                                    {d.item.boCnt > 0 &&
                                                        <Col sm={12}>
                                                            <div className="icons-row alert-noti bo-noti text-left">
                                                                <span className="svg-holder small-svg">
                                                                    <img className="white-filter" src="../../../Images/backorder.svg" alt="Alert" />
                                                                </span>

                                                                <p className="mb-0">This item is backordered</p>
                                                            </div>
                                                        </Col>
                                                    } 
                                                </Row>

                                                <Row>                                            
                                                    <Col sm={12}>
                                                        <Row className="mt-3">
                                                            <Col sm={4} lg={2}>
                                                                <Row>
                                                                    <Col sm={1} className="mt-5 padding-left-extra-md padding-right-extra-sm">
                                                                        {(d.item.itemStaCode === "1" || d.item.itemStaCode === "2") && 
                                                                            <Form.Check
                                                                                type={'checkbox'}
                                                                                id={'check' + d.item.distitemNbr}
                                                                                aria-label="Item 1"
                                                                                name="invoiceNum-checkbox"
                                                                                checked={SelectedSKUs.has(d.item.distitemNbr.replaceAll('-', ''))}
                                                                                onChange={handleSelectItem}
                                                                            />
                                                                        }
                                                                    </Col>

                                                                    <Col sm={10} className="item-inquiry-image">
                                                                        <img src={KImageURL(d.item.distitemNbr, d.addInfo.img)} 
                                                                            onError={({ currentTarget }) => {
                                                                                currentTarget.onerror = null;
                                                                                currentTarget.src = DefaultImage;
                                                                            }}
                                                                            alt="Product"
                                                                            className={d.item.factorAlert || d.item.statusIcon.indexOf('.svg') > -1 || d.item.ltl || d.item.substitutedSKU !== '' || d.item.boCnt > 0 ? "item-image red-border" : "item-image"}>
                                                                        </img>
                                                                    </Col>
                                                                </Row>
                                                            </Col>

                                                            <Col sm={4} lg={2} className="text-left">
                                                                <p className={d.item.factorAlert || d.item.statusIcon.indexOf('.svg') > -1 || d.item.ltl || d.item.substitutedSKU !== '' || d.item.boCnt > 0 ? "mb-0 red" : "mb-0"}>{d.addInfo && d.addInfo.itemDesc}</p>
                                                                <p className="mb-0">
                                                                    <Trans
                                                                        i18nKey="form.Item No"
                                                                        components={{ sup: <sup /> }}
                                                                    />
                                                                    : {d.item.distitemNbr}
                                                                </p>
                                                                <div className="icons-row">
                                                                    <span className="svg-holder small-svg">
                                                                        <img src={"../../../Images/" + d.item.inventoryTypeIcon} alt={d.item.inventoryTypeIcon} ></img>
                                                                    </span>

                                                                    {d.item.statusIcon.indexOf('.svg') > -1 ?
                                                                        <>|<span className="svg-holder small-svg"><img className="margin-left" src={"../../../Images/" + d.item.statusIcon} alt={d.item.statusIcon}></img></span></> :
                                                                        <>|<span className="svg-holder small-svg"><div className={`status-icon ${d.item.statusIcon}`}></div></span></>
                                                                    }

                                                                    {d.item.boCnt > 0 && <>|<span className="svg-holder small-svg"><img src="../../../Images/backorder.svg" alt="Alert" className="margin-left" /></span></>}

                                                                    {d.item.factorAlert &&
                                                                        <>|<span className="svg-holder small-svg"><img src="../../../Images/asterisk.svg" alt="asterisk" className="asterisk-img margin-left" /></span></>
                                                                    }

                                                                    {d.item.ltl &&
                                                                        <>|<span className="svg-holder small-svg"><img src="../../../Images/LTL.svg" alt="LTL" className="margin-left" /></span></> 
                                                                    }
                                                                </div>

                                                                {d.addInfo && 
                                                                    <DropdownButton
                                                                        variant="outline-dark"
                                                                        title={t("form.View Details")}
                                                                        id="details-dropdown"
                                                                        className="mt-2 mb-2 dropdown-info"
                                                                    >
                                                                        <Dropdown.ItemText><span className="bold">{t('form.Vehicle Use')}:</span> {d.addInfo.prodLinesText}</Dropdown.ItemText>
                                                                        <Dropdown.Item><span className="bold">{t('form.Model Year(s)')}:</span> {d.addInfo.yearString} <span className="underline" onClick={() => handleModelModalShow(d.item.distitemNbr)}>{t('form.View Models')}</span></Dropdown.Item>
                                                                        {/*<Dropdown.Item><span className="bold">Eligible Exchange/Return:</span> {d.addInfo.eligibleExchangeReturn}</Dropdown.Item>*/}
                                                                        <Dropdown.Item><span className="bold">{t('form.Dimensions (LxWxHxG) (In)')}:</span> {d.addInfo.dimentions}</Dropdown.Item>
                                                                        <Dropdown.Item><span className="bold">{t('form.Weight (lb) / Volume (ci)')}:</span> {d.addInfo.weightVal}</Dropdown.Item>
                                                                    </DropdownButton>
                                                                }
                                                            </Col>
                                                            <Col sm={4} lg={2}>
                                                                <Table bordered>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                <Trans
                                                                                    i18nKey="form.Dealer Price"
                                                                                    components={{ br: <br /> }}
                                                                                />
                                                                            </th>
                                                                            <th>{t('form.MSRP')}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>{FormatCurrency(d.item.dealerPrice)}</td>
                                                                            <td>{FormatCurrency(d.item.retailPrice)}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                            </Col>
                                                            <Col sm={3} lg={1}>
                                                                <Table bordered>
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="black-bg">
                                                                                <Trans
                                                                                    i18nKey="form.Order Qty"
                                                                                    components={{ br: <br /> }}
                                                                                />
                                                                            </th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>{d.item.qtyOrdered}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                            </Col>
                                                            <Col sm={9} lg={5}>
                                                                <Table bordered>
                                                                    <thead>
                                                                        <tr>
                                                                            <th>
                                                                                <Trans
                                                                                    i18nKey="form.Avail Qty"
                                                                                    components={{ br: <br /> }}
                                                                                />
                                                                            </th>
                                                                            <th>CA (L)</th>
                                                                            <th>KY (R)</th>
                                                                            <th>TX (D)</th>
                                                                            <th>
                                                                                <Trans
                                                                                    i18nKey="form.Pkg Qty"
                                                                                    components={{ br: <br /> }}
                                                                                />
                                                                            </th>
                                                                            {d.item.boCnt > 0 && <th>BO</th>}
                                                                            <th>{t('form.Exc / Rtn')}</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr>
                                                                            <td>{d.item.qty}</td>
                                                                            <td>{getStatusIcon(d.item.warehouseAvailColorL)}</td>
                                                                            <td>{getStatusIcon(d.item.warehouseAvailColorR)}</td>
                                                                            <td>{getStatusIcon(d.item.warehouseAvailColorD)}</td>
                                                                            <td>{d.item.whslePkgCnt}</td>
                                                                            {d.item.boCnt > 0 && <td>{d.item.boCnt}</td>}
                                                                            <td>{d.addInfo.eligibleExchangeReturn}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </Table>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                       
                                                </Row>
                                            </div>
                                        ))}
                                    </div>
                                </>
                                : pop &&
                                <>
                                    <PulseLoader color="#66cc33" size="20px" margin="12px" className="mt-5" />
                                </>
                            }
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer className="black-bg">
                    <Row className="w-100w">
                        {!localFromImport &&
                            <>
                                <Col>
                                    <Button variant="secondary" onClick={resetItems} className="btn-maintain">
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        {t('button.RESET SEARCH')}
                                    </Button>
                                </Col>
                                <Col>
                                    <Button variant="primary" onClick={AddSkuClick}>
                                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                        </svg>
                                        {t('button.SUBMIT')}
                                    </Button>
                                </Col>
                            </>     
                        }
                        {ShowAddToOrder ?
                        
                            <Col sm={12} lg={!localFromImport ? { span: 2, offset: 7 } : { span: 2, offset: 10 }} className="text-right">
                                <Button variant="primary" onClick={handleSubmit}>
                                    <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill" viewBox="0 0 16 16" role="presentation">
                                        <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                                    </svg>
                                    {t('button.ADD TO ORDER')}
                                </Button>
                            </Col>
                            :
                            <Col sm={9}>
                            </Col>
                        }
                    </Row>
                </Modal.Footer>
            </Modal>

            <Modal show={showModelModal} onHide={handleModelModalClose} backdrop="static" centered dialogClassName="dealer-section model-window">
                <Modal.Header closeButton style={{ justifyContent: 'center' }}>
                    <Modal.Title>{t('popup.MODELS')}</Modal.Title>
                    <CloseButton variant="white" data-bs-theme="dark" />
                </Modal.Header>
                <Modal.Body>
                    {!Models ?
                        <PulseLoader color="#66cc33" size="20px" margin="12px" className="mt-5" />
                    :     
                        <Table bordered hover striped>
                            <thead>
                                <tr>
                                    <td colSpan="3">{SelectedItemForModels && SelectedItemForModels.itemNum}, {SelectedItemForModels && SelectedItemForModels.itemName}</td>
                                </tr>
                                {Models.length > 0 && <tr>
                                    <td colSpan="3">{t('popup.This item fits the following models')}:</td>
                                </tr>}
                               
                            </thead>
                            <tbody>
                                {Models.length > 0? Models.map((d) =>
                                    <>
                                        {d.models.map((m) =>
                                            <tr>
                                                <td>{m.year}</td>
                                                <td>{m.label}</td>
                                                <td>{m.value}</td>
                                            </tr>)}
                                        <tr>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                    </>

                                ) :
                                    <tr>This item has no model restrictions.</tr>
                            }
                            </tbody>
                            
                        </Table>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleModelModalClose}>
                        <svg xmlns="https://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-caret-right-fill green" viewBox="0 0 16 16" role="presentation">
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                        </svg>
                        {t('button.CLOSE')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default ItemInquiry;